import { cls } from './formStyles';

/**
 * Shared by the intake's About you section and the onboarding form's "Your details"
 * (crossmarc/steward-app#1883): both show the invited address read-only. The text below was
 * written for the intake (its "section 1" is the intake wizard's); the onboarding form passes
 * the address from the server, so its `email` is normally non-empty (empty if the server could
 * not read it). The "never puts an email key into the draft" claim below is the intake's; the
 * onboarding form's save still sends `client_email` and the façade overwrites it.
 *
 * What an INVITED client sees where the email field would be (crossmarc/steward-app#1555).
 *
 * Two states, and the EMPTY one is what every invited client meets first: About You is
 * section 1, the wizard saves on a section move, and the address is stamped onto the draft by
 * the writer on that first save — so on the first render there is nothing to show yet. An
 * empty disabled input with a placeholder would read as a field waiting to be filled in,
 * which is the opposite of what is true, so that state is a sentence rather than a control.
 *
 * 🚨 No input, of either kind, in either state. What matters is that this section never puts
 * an `email` key into the draft on an invited form: the writer stamps the address from the
 * invitation row on every save and again on submit, so a value typed here would be
 * overwritten rather than honoured. Collecting one would be theatre, and a way for the two to
 * disagree in the meantime — which is the whole of what #1555 was opened to remove.
 */
export function InvitedEmail({ email }: { email: string }) {
  return (
    <div>
      <span className={cls.label}>Email</span>
      {/* `bg-cream` (the page plate) rather than `surface`: it reads as inert beside the real
          inputs around it, without pretending to be a disabled one. */}
      {email
        ? (
          <p className="mt-0 mb-0 px-3 py-2 text-[13px] border border-line rounded-token bg-cream text-navy break-words">
            {email}
          </p>
        )
        : null}
      <p className={`mb-0 text-[12px] text-slate ${email ? 'mt-1' : 'mt-0'}`}>
        {email
          ? 'This is the address used for your invitation. If it is not correct, ask them to send a new one.'
          : 'Your advisor already has your email address, so we do not ask for it again here.'}
      </p>
    </div>
  );
}
